import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class RatesViewModel {
    ShowAlert:             (pTitle: string, pMessage: string) => void;
    NewLoading:            (pMessage: string)                 => dmLoading;
    BackToSignIn:          ()                                 => void;
    DetectWidth:           ()                                 => number;
    RegisterResize:        (pAction: () => void)              => void;
    ShowCalendar:          (
         pToday:           Date
        ,pCDay:            Date
        ,pTitle:           string
        ,pLangID:          number
        ,pAction:          (pCDay: Date)                      => void
    )                                                         => void;
    ShowPeriodCalendar:    (
         pToday:           Date
        ,pArr:             Date
        ,pDep:             Date
        ,pTitle:           string
        ,pLangID:          number
        ,pAction:          (pFrom: Date, pTo: Date)           => void
    )                                                         => void;

    mlText:                MLText;
    app:                   mlBroker;
    ml:                    mlBroker;
    Hotel:                 dmHotel;
    LangID:                number;

    InRefresh:             boolean;
    NumDaysAll:            number;
    NumDays:               number;

    RoomTypes:             RQService.Pms.GetRoomTypesRow[];
    OfferTypes:            RQService.Pms.GetOfferTypesRow[];
    MaxPersons:            RQService.Pms.GetMaxPersonsRateNamesByRoomTypeRow[];
    RateDays:              RQService.Pms.GetRatePeriodRow[];
    DisplayDays:           RQService.Pms.GetRatePeriodRow[];

    SelectRoomTypeTitle:   string;
    SelectOfferTypeTitle:  string;
    SelectMaxPersonsTitle: string;

    SelectedRoomTypeID:    number;
    SelectedOfferTypeID:   number;
    SelectedMaxPersons:    number;
    Today:                 Date;
    StartDate:             Date;
    StartDateDisplay:      string;
    StartDateModified:     boolean;

    EndPeriodDate:         Date;
    EndPeriodDisplay:      string;

    CalHasTwoMonths:       boolean;
    FirstMonthLabel:       string;
    SecondMonthLabel:      string;

    IsDiscountFilter:      boolean;

    SourceMLOS:            boolean;
    SourceMaxStay:         boolean;
    SourceAdvanceDays:     boolean;
    SourceNoArr:           boolean;
    SourceNoDep:           boolean;

    WithPeriod:            boolean;

    PeriodStartDate:       Date;
    PeriodEndDate:         Date;
    PeriodModified:        boolean;
    PeriodStartDisplay:    string;
    PeriodEndDisplay:      string;
    Close:                 boolean;

    options: boolean; // showing day by day or period base
    RatesPeriodPrice: number;
    MLOS: number;
    MaxStay: number;
    AdvanceDays: number;
    NoArr: boolean;
    NoDep: boolean;
    Day1: boolean;
    Day2: boolean;
    Day3: boolean;
    Day4: boolean;
    Day5: boolean;
    Day6: boolean;
    Day7: boolean;
    ShowGrid: boolean;

    constructor(
         pMLText:             MLText
        ,pHotel:              dmHotel
        ,pBackToSignIn:       ()                                 => void
        ,pShowAlert:          (pTitle: string, pMessage: string) => void
        ,pNewLoading:         (pMessage: string)                 => dmLoading
        ,pDetectWidth:        ()                                 => number
        ,pRegisterResize:     (pAction: () => void)              => void
        ,pShowCalendar:       (
             pToday:          Date
            ,pCDay:           Date
            ,pTitle:          string
            ,pLangID:         number
            ,pAction:         (pCDay: Date)                      => void
        )                                                        => void
        ,pShowPeriodCalendar: (
             pToday:          Date
            ,pStart:          Date
            ,pEnd:            Date
            ,pTitle:          string
            ,pLangID:         number
            ,pAction:         (pFrom: Date, pTo: Date)           => void
        )                                                        => void
    ) {
        this.mlText                = pMLText;
        this.LangID                = this.mlText.GetLangID();
        this.app                   = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                    = this.mlText.GetBroker(
            'HotelAreaRates'
        );

        this.Hotel                 = pHotel;
        this.BackToSignIn          = pBackToSignIn;
        this.ShowAlert             = pShowAlert;
        this.NewLoading            = pNewLoading;
        this.DetectWidth           = pDetectWidth;
        this.RegisterResize        = pRegisterResize;
        this.ShowCalendar          = pShowCalendar;
        this.ShowPeriodCalendar    = pShowPeriodCalendar;

        this.InRefresh             = false;
        this.NumDaysAll            = 30;

        this.RoomTypes             = [];
        this.OfferTypes            = [];
        this.MaxPersons            = [];
        this.RateDays              = [];

        this.SelectedRoomTypeID    = 0;
        this.SelectedOfferTypeID   = 0;
        this.SelectedMaxPersons    = 0;
        this.StartDateModified     = false;

        this.IsDiscountFilter      = false;

        this.SourceMLOS            = false;
        this.SourceMaxStay         = false;
        this.SourceAdvanceDays     = false;
        this.SourceNoArr           = false;
        this.SourceNoDep           = false;

        this.WithPeriod            = true;

        this.DisplayDays           = [];

        this.PeriodModified        = false;
        this.Close                 = true;

        this.SelectRoomTypeTitle   = this.ml.Text(
             'ChooseRoomType'
            ,'Choose Room Type'
        );

        this.SelectOfferTypeTitle  = this.ml.Text(
             'ChooseRatePackage'
            ,'Choose Rate Package'
        );

        this.SelectMaxPersonsTitle = this.ml.Text(
             'ChooseMaxPersons'
            ,'Choose Usage Reductions'
        );

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        this.NumDays = this.numDaysFromWidth(this.DetectWidth());

        this.RegisterResize(() => {
            this.refreshNumDays(this.numDaysFromWidth(this.DetectWidth()));
        });

        this.InRefresh = true;
        this.options = true;
        this.ShowGrid = false;

        this.Day1 = true;
        this.Day2 = true;
        this.Day3 = true;
        this.Day4 = true;
        this.Day5 = true;
        this.Day6 = true;
        this.Day7 = true;


        loading.Show(() => {
            this.refreshRateDays(() => { this.InRefresh = false; loading.Dismiss(); });
        });
    }

    private numDaysFromWidth(pWidth: number): number {
        let numDays: number = 0;

        if (pWidth < 768) {
            numDays = Math.floor((pWidth - 130) / 70);
        } else {
            numDays = Math.floor((pWidth - 440) / 70);
        }

        if (numDays < 4)  { numDays = 4;  }
        if (numDays > 30) { numDays = 30; }

        return numDays;
    }

    private refreshNumDays(pNumDays: number): void {
        this.NumDays = pNumDays;

        if (this.NumDays > 30) { this.NumDays = 30 }

        this.DisplayDays.length = 0;

        let date_idx: Date = new Date(
             this.StartDate.getFullYear()
            ,this.StartDate.getMonth()
            ,this.StartDate.getDate()
        );

        for (let i = 0; i < this.NumDays; i++) {
            let day:        RQService.Pms.GetRatePeriodRow = null;
            let dayInCache: boolean                        = false;

            for (let i = 0; i < this.RateDays.length; i++) {
                let resDay: Date = new Date(
                     Number(this.RateDays[i].CDay.substr(0, 4))
                    ,Number(this.RateDays[i].CDay.substr(5, 2)) - 1
                    ,Number(this.RateDays[i].CDay.substr(8, 2))
                );

                if (resDay.valueOf() == date_idx.valueOf()) {
                    day        = this.RateDays[i]
                    dayInCache = true;

                    break;
                }
            }

            if (!dayInCache) {
                day = RQService.Pms.PopulateGetRatePeriodRow({ });

                this.initNonCacheDay(day, date_idx);
            }

            this.DisplayDays.push(day);

            date_idx.setDate(date_idx.getDate() + 1);
        }

        this.updateDateDisplay();
    }

    private initNonCacheDay(
         pNonCacheDay: RQService.Pms.GetRatePeriodRow
        ,pCDay:        Date
    ): void {
        pNonCacheDay.CDay     = RQApp.JSDateToRQString(pCDay, false);
        pNonCacheDay.Price    = 0;
        pNonCacheDay.MLOS     = 0;
        pNonCacheDay.MaxStay  = 0;
        pNonCacheDay.NoArr    = false;
        pNonCacheDay.NoDep    = false;
        pNonCacheDay.StopSell = false;
    }

    private refreshRateDays(pAction: () => void): void {
        this.updateNotionOfToday();

        //DO NOT UPDATE DATE-DISPLAY WHEN COMING FROM PERIOD-SELECTION
        if (this.options) {
            this.updateDateDisplay();
            this.ShowGrid = false;
        }
        
        let roomTypeParams = RQParam.PmsGetRoomTypesParams();

        roomTypeParams.HotelID = this.Hotel.HotelID;
        roomTypeParams.LangID  = this.LangID;

        RQService.Pms.GetRoomTypes(roomTypeParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pAction(); return; }

            let roomTypes = response.RQueryResult;

            this.RoomTypes.length = 0;

            for (let i = 0; i < roomTypes.length; i++) {
                let roomType = RQService.Pms.PopulateGetRoomTypesRow(
                    roomTypes[i]
                );
                
                this.RoomTypes.push(roomType);
            }

            if (this.SelectedRoomTypeID == 0) {
                if (roomTypes.length > 0) {
                    this.SelectedRoomTypeID = this.RoomTypes[0].RoomTypeID;
                } else {
                    this.SelectedRoomTypeID = 0;
                }
            }

            let offerTypeParams = RQParam.PmsGetOfferTypesParams();

            offerTypeParams.HotelID = this.Hotel.HotelID;
            offerTypeParams.LangID  = this.Hotel.LangID;

            RQService.Pms.GetOfferTypes(offerTypeParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { pAction(); return; }
                
                let offerTypes = response.RQueryResult;

                this.OfferTypes.length = 0;
                
                for (let i = 0; i < offerTypes.length; i++) {
                    let offerType = RQService.Pms.PopulateGetOfferTypesRow(
                        offerTypes[i]
                    );
                
                    this.OfferTypes.push(offerType);
                }

                if (this.SelectedOfferTypeID == 0) {
                    if (offerTypes.length > 0) {
                        this.SelectedOfferTypeID = this.OfferTypes[0].OfferTypeID;
                    } else {
                        this.SelectedOfferTypeID = 0;
                    }
                }

                this.IsDiscountFilter  = false;

                this.SourceMLOS        = false;
                this.SourceMaxStay     = false;
                this.SourceAdvanceDays = false;
                this.SourceNoArr       = false;
                this.SourceNoDep       = false;

                this.WithPeriod        = true;

                for (let i = 0; i < this.OfferTypes.length; i++) {
                    if (this.SelectedOfferTypeID == this.OfferTypes[i].OfferTypeID) {
                        this.IsDiscountFilter = (this.OfferTypes[i].IsDiscountFilter == 1);

                        if (this.IsDiscountFilter) {
                            this.SourceMLOS        = (this.OfferTypes[i].SourceMLOS        != 0);
                            this.SourceMaxStay     = (this.OfferTypes[i].SourceMaxStay     != 0);
                            this.SourceAdvanceDays = (this.OfferTypes[i].SourceAdvanceDays != 0);
                            this.SourceNoArr       = (this.OfferTypes[i].SourceNoArr       != 0);
                            this.SourceNoDep       = (this.OfferTypes[i].SourceNoDep       != 0);

                            if (
                                this.SourceMLOS
                            &&  this.SourceMaxStay
                            &&  this.SourceAdvanceDays
                            &&  this.SourceNoArr
                            &&  this.SourceNoDep
                            ) {
                                this.WithPeriod = false; console.log('WPF');

                                this.updateDateDisplay();

                                this.options  = true;
                                this.ShowGrid = false;
                            }
                        }

                        break;
                    }
                }

                let maxPersonsParams = RQParam.PmsGetMaxPersonsRateNamesByRoomTypeParams();

                maxPersonsParams.HotelID    = this.Hotel.HotelID;
                maxPersonsParams.RoomTypeID = this.SelectedRoomTypeID;
                maxPersonsParams.LangID     = this.LangID;

                RQService.Pms.GetMaxPersonsRateNamesByRoomType(maxPersonsParams).then((result) => {
                    let response = result as any;

                    if (response.HasErrorOrException) { pAction(); return; }
                    
                    let maxPersons = response.RQueryResult;

                    this.MaxPersons.length = 0;
                    
                    for (let i = 0; i < maxPersons.length; i++) {
                        let usageReduction
                            = RQService.Pms.PopulateGetMaxPersonsRateNamesByRoomTypeRow(
                                maxPersons[i]
                            );                   

                        this.MaxPersons.push(usageReduction);
                    }

                    let foundRoomTypeSelection: boolean = false;

                    for (let i = 0; i < this.RoomTypes.length; i++) {
                        let roomType = this.RoomTypes[i];

                        if (this.SelectedRoomTypeID == roomType.RoomTypeID) {
                            foundRoomTypeSelection = true;

                            if (this.SelectedMaxPersons >= roomType.PersonsNormal) {
                                this.SelectedMaxPersons = 0;
                            }
                        }
                    }

                    if (!foundRoomTypeSelection) { this.SelectedMaxPersons = 0; }

                    let rateParams = RQParam.PmsGetRatePeriodParams();
                    let endDate    = new Date(this.StartDate);

                    endDate.setDate(this.StartDate.getDate() + (this.NumDaysAll - 1));
                    rateParams.HotelID     = this.Hotel.HotelID;
                    rateParams.RoomTypeID  = this.SelectedRoomTypeID;
                    rateParams.OfferTypeID = this.SelectedOfferTypeID;
                    rateParams.MaxPersons  = this.SelectedMaxPersons;
                    rateParams.StartDate   = RQApp.JSDateToRQString(this.StartDate ,false);
                    rateParams.EndDate      = RQApp.JSDateToRQString(endDate, false);
                    rateParams.LangID       = this.LangID;

                    RQService.Pms.GetRatePeriod(rateParams).then((result) => {
                        let response = result as any;
                        if (response.HasErrorOrException) { pAction(); return; }
                        
                        let days = response.RQueryResult;

                        this.RateDays.length = 0;

                        for (let i = 0; i < days.length; i++) {
                            let day = RQService.Pms.PopulateGetRatePeriodRow(
                                days[i]                                
                            );
                            
                            this.RateDays.push(day);
                        }

                        this.DisplayDays.length = 0;

                        let date_idx: Date = new Date(
                             this.StartDate.getFullYear()
                            ,this.StartDate.getMonth()
                            ,this.StartDate.getDate()
                        );

                        for (let i = 0; i < this.NumDays; i++) {
                            let day:        RQService.Pms.GetRatePeriodRow = null;
                            let dayInCache: boolean                        = false;

                            for (let i = 0; i < this.RateDays.length; i++) {
                                let resDay: Date = new Date(
                                     Number(this.RateDays[i].CDay.substr(0, 4))
                                    ,Number(this.RateDays[i].CDay.substr(5, 2)) - 1
                                    ,Number(this.RateDays[i].CDay.substr(8, 2))
                                );

                                if (resDay.valueOf() == date_idx.valueOf()) {
                                    day        = this.RateDays[i]
                                    dayInCache = true;

                                    break;
                                }
                            }

                            if (!dayInCache) {
                                day = RQService.Pms.PopulateGetRatePeriodRow({ });

                                this.initNonCacheDay(day, date_idx);
                            }

                            this.DisplayDays.push(day);

                            date_idx.setDate(date_idx.getDate() + 1);
                        }

                        pAction();
                    });
                });
            });
        });
    }

    private updateNotionOfToday(): void {
        let now    = new Date();
        
        this.Today = new Date(
             now.getFullYear()
            ,now.getMonth()
            ,now.getDate()
        );

        if (!this.StartDateModified) {
            this.StartDate        = new Date(
                 this.Today.getFullYear()
                ,this.Today.getMonth()
                ,this.Today.getDate()
            );

            this.StartDateDisplay = RQApp.JSDateToRQString(this.StartDate, false);
        }

        if (!this.PeriodModified) {
            this.PeriodStartDate    = new Date(
                 this.Today.getFullYear()
                ,this.Today.getMonth()
                ,this.Today.getDate()
            );

            this.PeriodEndDate      = new Date(this.StartDate);

            this.PeriodEndDate.setDate(this.StartDate.getDate() + 1);

            this.PeriodStartDisplay = RQApp.JSDateToRQString(
                 this.PeriodStartDate
                ,false
            );

            this.PeriodEndDisplay   = RQApp.JSDateToRQString(
                 this.PeriodEndDate
                ,false
            );
        }
    }

    private updateDateDisplay() {
        this.StartDateDisplay   = RQApp.JSDateToRQString(this.StartDate       ,false);
        this.PeriodStartDisplay = RQApp.JSDateToRQString(this.PeriodStartDate ,false);
        this.PeriodEndDisplay   = RQApp.JSDateToRQString(this.PeriodEndDate   ,false);

        this.FirstMonthLabel    = this.StartDate.toLocaleString(
             RQApp.LangCodesByID[this.LangID]
            ,{ month: 'long' }
        ) + ' ' + this.StartDate.getFullYear().toString();

      let endDate: Date = new Date(
             this.StartDate.getFullYear()
            ,this.StartDate.getMonth()
            ,this.StartDate.getDate()
        );

        endDate.setDate(endDate.getDate() + this.NumDays);

        if (this.StartDate.getMonth() == endDate.getMonth()) {
            this.CalHasTwoMonths  = false;
            this.SecondMonthLabel = '';
        } else {
            this.CalHasTwoMonths  = true;
            this.SecondMonthLabel = endDate.toLocaleString(
                 RQApp.LangCodesByID[this.LangID]
                ,{ month: 'long' }
            ) + ' ' + this.StartDate.getFullYear().toString();
        }

        this.EndPeriodDate = endDate;
        this.EndPeriodDisplay = RQApp.JSDateToRQString(endDate, false);

    }

    public FormatPrice(pPrice: number): string {
        if (Number.isInteger(pPrice)) { return pPrice.toString(); }
        else                          { return pPrice.toFixed(2); }
    }

    public SelectOfferType(event: any) {
        if (this.InRefresh) { return; }

        let offerTypeID = event as number;

        this.SelectedOfferTypeID = offerTypeID;

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshRateDays(() => { loading.Dismiss(); });
        });
    }

    public SelectRoomType(event: any) {
        if (this.InRefresh) { return; }

        let roomTypeID = event as number;

        this.SelectedRoomTypeID = roomTypeID;

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshRateDays(() => { loading.Dismiss(); });
        });
    }

    public SelectMaxPersons(event: any) {
        if (this.InRefresh) { return; }

        let maxPersons = event as number;

        this.SelectedMaxPersons = maxPersons;

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshRateDays(() => { loading.Dismiss(); });
        });
    }

    public ChangeCalDate(pStartDate: Date): void {
        if (this.InRefresh)                                    { return; }
        if (this.StartDate.getTime() === pStartDate.getTime()) { return; }

        this.StartDateModified = true;

        this.StartDate         = pStartDate;

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshRateDays(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public ChangeCalPeriod(pStartDate: Date, pEndDate: Date): void {
        if (this.InRefresh) { return; }

        if (
            this.PeriodStartDate.getTime() === pStartDate.getTime()
        &&  this.PeriodEndDate.getTime()   === pEndDate.getTime()
        ) { return; }

        this.PeriodModified  = true;
        this.PeriodStartDate = pStartDate;
        this.PeriodEndDate   = pEndDate;

        this.updateDateDisplay();
    }

    public CalDateNext() {
        if (this.InRefresh) { return; }

        this.StartDateModified = true;

        this.StartDate.setDate(this.StartDate.getDate() + (this.NumDays - 1));

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshRateDays(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public CalDatePrev() {
        if (this.InRefresh) { return; }

        this.StartDateModified = true;

        this.StartDate.setDate(this.StartDate.getDate() - (this.NumDays - 1));

        if (this.StartDate <= this.Today) {
            this.StartDate = new Date(
                 this.Today.getFullYear()
                ,this.Today.getMonth()
                ,this.Today.getDate()
            );
        }

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshRateDays(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public SaveRateData(
         pCDay:            string
        ,pWithPrice:       boolean
        ,pPrice:           string
        ,pWithMLOS:        boolean
        ,pMLOS:            string
        ,pWithMaxStay:     boolean
        ,pMaxStay:         string
        ,pWithAdvanceDays: boolean
        ,pAdvanceDays:     string
        ,pWithNoArr:       boolean
        ,pNoArr:           boolean
        ,pWithNoDep:       boolean
        ,pNoDep:           boolean
        ,pWithStopSell:    boolean
        ,pStopSell:        boolean
    ): void {
        if (this.InRefresh) { return; }

        if (pPrice == null || isNaN(Number(pPrice)) || Number(pPrice) < 0) { pPrice = '0'; }
        if (pMLOS  == null || isNaN(Number(pMLOS))  || Number(pMLOS)  < 0) { pMLOS  = '0'; }
        if (
            pMaxStay == null
        ||  isNaN(Number(pMaxStay))
        ||  Number(pMaxStay) < 0
        ) { pMaxStay = '0'; }

        let updateParams = RQParam.PmsAcceptRateUpdateDaysViaManualEntryFullParams();

        updateParams.HotelID         = this.Hotel.HotelID;
        updateParams.RoomTypeID      = this.SelectedRoomTypeID;
        updateParams.OfferTypeID     = this.SelectedOfferTypeID;
        updateParams.MaxPersons      = this.SelectedMaxPersons;
        updateParams.StartDate       = pCDay;
        updateParams.EndDate         = pCDay;
        updateParams.WithPrice       = (pWithPrice       ? 1 : 0);
        updateParams.Price           = Math.round(Number(pPrice) * 100) / 100;
        updateParams.WithMLOS        = (pWithMLOS        ? 1 : 0);
        updateParams.MLOS            = Math.floor(Number(pMLOS));
        updateParams.WithMaxStay     = (pWithMaxStay     ? 1 : 0);
        updateParams.MaxStay         = Math.floor(Number(pMaxStay));
        updateParams.WithAdvanceDays = (pWithAdvanceDays ? 1 : 0);
        updateParams.AdvanceDays     = Math.floor(Number(pAdvanceDays));
        updateParams.WithNoArr       = (pWithNoArr       ? 1 : 0);
        updateParams.NoArr           = (pNoArr           ? 1 : 0);
        updateParams.WithNoDep       = (pWithNoDep       ? 1 : 0);
        updateParams.NoDep           = (pNoDep           ? 1 : 0);
        updateParams.WithStopSell    = (pWithStopSell    ? 1 : 0);
        updateParams.StopSell        = (pStopSell        ? 1 : 0);
        updateParams.LangID          = this.LangID;

        let loading: dmLoading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        this.InRefresh = true;

        loading.Show(() => {
            RQService.Pms.AcceptRateUpdateDaysViaManualEntryFull(updateParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) {
                    this.InRefresh = false;

                    loading.Dismiss();

                    return;
                }

                this.refreshRateDays(() => { this.InRefresh = false; loading.Dismiss(); });
            });
        });
    }

    public EditStopSellPeriod(): void {
        if (this.InRefresh) { return; }

        let updateParams = RQParam.PmsAcceptRateUpdateDaysViaManualEntryFullParams();

        updateParams.HotelID         = this.Hotel.HotelID;
        updateParams.RoomTypeID      = this.SelectedRoomTypeID;
        updateParams.OfferTypeID     = this.SelectedOfferTypeID;
        updateParams.MaxPersons      = this.SelectedMaxPersons;
        updateParams.StartDate       = RQApp.JSDateToRQString(this.PeriodStartDate ,false);
        updateParams.EndDate         = RQApp.JSDateToRQString(this.PeriodEndDate   ,false);
        updateParams.WithPrice       = 0;
        updateParams.Price           = 0;
        updateParams.WithMLOS        = 0;
        updateParams.MLOS            = 0;
        updateParams.WithMaxStay     = 0;
        updateParams.MaxStay         = 0;
        updateParams.WithAdvanceDays = 0;
        updateParams.AdvanceDays     = 0;
        updateParams.WithNoArr       = 0;
        updateParams.NoArr           = 0;
        updateParams.WithNoDep       = 0;
        updateParams.NoDep           = 0;
        updateParams.WithStopSell    = 1;
        updateParams.StopSell        = (this.Close ? 1 : 0);
        updateParams.LangID          = this.LangID;

        let loading: dmLoading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        this.InRefresh = true;

        loading.Show(() => {
            RQService.Pms.AcceptRateUpdateDaysViaManualEntryFull(updateParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) {
                    this.InRefresh = false;

                    loading.Dismiss();

                    return;
                }

                this.refreshRateDays(() => { this.InRefresh = false; loading.Dismiss(); });
            });
        });
    }

    public ShowDateSelector(): void {
        if (this.InRefresh) { return; }

        this.updateNotionOfToday();

        this.ShowCalendar(
             this.Today
            ,this.StartDate
            ,this.ml.Text('ChooseRatePeriodStart' ,'Choose Rate Period Start')
            ,this.LangID
            ,(pStartDate: Date) => { this.ChangeCalDate(pStartDate); }
        );
    }

    public ShowPeriodSelector(): void {
        if (this.InRefresh) { return; }

        this.updateNotionOfToday();

        this.ShowPeriodCalendar(
             this.Today
            ,this.PeriodStartDate
            ,this.PeriodEndDate
            ,this.ml.Text('ChooseRatePeriod' ,'Choose Rate Period')
            ,this.LangID
            ,(pStartDate: Date, pEndDate: Date) => {
                this.ChangeCalPeriod(pStartDate, pEndDate);
            }
        );
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }


    // Period-Window-Part
    public ShowPeriodBeginSelector(): void {
        if (this.InRefresh) { return; }
        
        this.ShowCalendar(
            this.Today
            , this.StartDate
            , this.ml.Text('ChooseStartDay', 'Choose Start Day')
            , this.LangID
            , (pEndDate: Date) => { this.ChangeCalBeginPeriod(pEndDate); }
        );
    }

    public ShowPeriodEndSelector(): void {
        if (this.InRefresh) { return; }

        this.ShowCalendar(
            this.Today
            , this.EndPeriodDate
            , this.ml.Text('ChoosePeriodEnd', 'Choose Period End')
            , this.LangID
            , (pEndDate: Date) => { this.ChangeCalEndPeriod(pEndDate); }
        );        
    }

    public ChangeCalBeginPeriod(pStartDate: Date): void {
        if (this.InRefresh) { return; }
        if (this.StartDate.getTime() === pStartDate.getTime()) { return; }

        this.StartDateModified = true;

        this.StartDate = pStartDate;
        let selStartDate: Date = this.StartDate;


        if (this.StartDate > this.EndPeriodDate) {
            this.EndPeriodDate = new Date(
                this.StartDate.getFullYear()
                , this.StartDate.getMonth()
                , this.StartDate.getDate()
            );
            this.EndPeriodDisplay = RQApp.JSDateToRQString(this.EndPeriodDate, false);            
        } 

        this.StartDateDisplay = RQApp.JSDateToRQString(this.StartDate, false);
    }

    public ChangeCalEndPeriod(pEndDate: Date): void {
        if (this.InRefresh) { return; }

        this.EndPeriodDate = new Date(
            pEndDate.getFullYear()
            , pEndDate.getMonth()
            , pEndDate.getDate()
        );


        if (this.EndPeriodDate < this.StartDate) {
            this.StartDate = new Date(
                this.EndPeriodDate.getFullYear()
                , this.EndPeriodDate.getMonth()
                , this.EndPeriodDate.getDate()
            );
            this.StartDateDisplay = RQApp.JSDateToRQString(this.StartDate, false);
        } 

        this.EndPeriodDisplay = RQApp.JSDateToRQString(this.EndPeriodDate, false);      
    }

    public SavePeriodRate(): void {
        if (this.InRefresh) { return; }

        if (
            this.IsDiscountFilter
        &&  this.SourceMLOS
        &&  this.SourceMaxStay
        &&  this.SourceAdvanceDays
        &&  this.SourceNoArr
        &&  this.SourceNoDep
        ) { return; }

        if ((!this.IsDiscountFilter) && (!this.RatesPeriodPrice)) {
            this.ShowAlert(
                this.ml.Text(
                     'PriceIsMissing'
                    ,'Price is Missing'
                )
                ,this.ml.Text(
                     'RatePerNight'
                    ,'Rate per night'
                )
            );
            return;
        }

        let pNoArr = 0; //: number;
        let pNoDep = 0; //: number;

        if (this.NoArr == true) { pNoArr = 1 } else { pNoArr = 0 };
        if (this.NoDep == true) { pNoDep = 1 } else { pNoDep = 0 };

        let pDay1 = 0;
        let pDay2 = 0;
        let pDay3 = 0;
        let pDay4 = 0;
        let pDay5 = 0;
        let pDay6 = 0;
        let pDay7 = 0;

        if ((!this.Day1) && (!this.Day2) && (!this.Day3) && (!this.Day4) && (!this.Day5) && (!this.Day6) && (!this.Day7)) {
            this.ShowAlert(
                this.ml.Text(
                    'NoDaySelected'
                    , 'No Day Selected'
                ),
                this.ml.Text(
                    'SelectADay'
                    , 'Select a day'
                )
            );
            return;
        }

        if (this.Day1 == true) { pDay1 = 1 };
        if (this.Day2 == true) { pDay2 = 1 };
        if (this.Day3 == true) { pDay3 = 1 };
        if (this.Day4 == true) { pDay4 = 1 };
        if (this.Day5 == true) { pDay5 = 1 };
        if (this.Day6 == true) { pDay6 = 1 };
        if (this.Day7 == true) { pDay7 = 1 };
       
        let blockParams = RQParam.PmsAcceptRateUpdateWeekDaysViaManualEntryFullParams();

        blockParams.HotelID = this.Hotel.HotelID;
        blockParams.RoomTypeID = this.SelectedRoomTypeID;
        blockParams.OfferTypeID = this.SelectedOfferTypeID;
        blockParams.MaxPersons = this.SelectedMaxPersons;
    
        blockParams.StartDate = this.StartDateDisplay;
        blockParams.EndDate = this.EndPeriodDisplay;

        if (this.IsDiscountFilter) {
            blockParams.WithPrice = 0;
            blockParams.Price = 0;
        } else {
            blockParams.WithPrice = 1;
            blockParams.Price = this.RatesPeriodPrice;
        }

        if (this.IsDiscountFilter && this.SourceMLOS) {
            blockParams.WithMLOS = 0;
            blockParams.MLOS = 0;
        } else {
            blockParams.WithMLOS = 1;
            blockParams.MLOS = this.MLOS;
        }

        if (this.IsDiscountFilter && this.SourceMaxStay) {
            blockParams.WithMaxStay = 0;
            blockParams.MaxStay = 0;
        } else {
            blockParams.WithMaxStay = 1;
            blockParams.MaxStay = this.MaxStay;
        }

        if (this.IsDiscountFilter && this.SourceAdvanceDays) {
            blockParams.WithAdvanceDays = 0;
            blockParams.AdvanceDays = 0;
        } else {
            blockParams.WithAdvanceDays = 1;
            blockParams.AdvanceDays = this.AdvanceDays;
        }

        if (!this.MLOS) {
            blockParams.MLOS = 0;
        }

        if (!this.MaxStay) {               
            blockParams.MaxStay = 0;
        }

        if (!this.AdvanceDays) {
            blockParams.AdvanceDays = 0;
        }

        if (this.IsDiscountFilter && this.SourceNoArr) {
            blockParams.WithNoArr = 0;
            blockParams.NoArr = 0;
        } else {
            blockParams.WithNoArr = 1;
            blockParams.NoArr = pNoArr;
        }

        if (this.IsDiscountFilter && this.SourceNoDep) {
            blockParams.WithNoDep = 0;
            blockParams.NoDep = 0;
        } else {
            blockParams.WithNoDep = 1;
            blockParams.NoDep = pNoDep;
        }

        blockParams.WithStopSell = 0;
        blockParams.StopSell = 0;
 
        blockParams.mon = pDay1;
        blockParams.tue = pDay2;
        blockParams.wed = pDay3;
        blockParams.thu = pDay4;
        blockParams.fri = pDay5;
        blockParams.sat = pDay6;
        blockParams.sun = pDay7;

        blockParams.LangID = this.LangID;      
        
        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        this.refreshRateDays(() => { loading.Dismiss(); });

        loading.Show(() => {
            RQService.Pms.AcceptRateUpdateWeekDaysViaManualEntryFull(blockParams).then((result) => {

                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }
                this.ShowGrid = true;
                this.refreshRateDays(() => { loading.Dismiss(); });
            });
        });
    }

    public disableGrid() {
        this.ShowGrid = false;
    }
}


// WEBPACK FOOTER //
// ./src/pages/rates/xv-rates.ts